export const getDisplayCoordinates = (runRec, coordsState, coords) => {
  if (runRec || coordsState.length) {
    return coordsState;
  }
  if (coords) {
    return coords.reverse();
  }
  return [];
};

export default getDisplayCoordinates;
